module.exports = require("@visx/glyph");